export default __webpack_public_path__ + "static/media/backIcon.3eed69fb.svg";